/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://bf7z4xbeqncqrfbb4l3rki4pkq.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-xi25ib754jbzzd47wvacnonenq",
    "aws_cognito_identity_pool_id": "us-east-1:b6a2d7a3-3f80-4b59-ae9a-101e1db0e30e",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_pTP3nUIXZ",
    "aws_user_pools_web_client_id": "3ih0nq4v5tua66lhcuhb394b2e",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
